import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocalParticipant, useDaily, useDevices } from '@daily-co/daily-react';
import { pageAtom, isAuthAtom, cameraInputAtom, topMessageAtom } from '../../State';
import { getAuth, signOut } from 'firebase/auth';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import AddAccess from '../Util/AddAccess';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Loading from '../Loading/Loading';
import KUTE from 'kute.js';
import DataModel from '../Util/DataModel';

//アイコン系
import { ReactComponent as LanguageSVG } from '../Images/buttons/settingLanguageButton.svg';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeBlackButton.svg';
//MUI系コンポーネント
import { useTranslation } from 'react-i18next';

export default function BrowserMyRoom({ meetingIDState, setMeetingIDState }) {
  const { t, i18n } = useTranslation();
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const [topMessageState, setTopMessageState] = useRecoilState(topMessageAtom);

  const [isLoadedState, setIsLoadedState] = useState(false);
  const navigate = useNavigate(); //リダイレクト用
  const closeWindow = (e) => {
    setPageState('main');
  };

  const tapCopy = (e) => {
    const url = 'https://faceless.ooo/' + meetingIDState;
    navigator.clipboard.writeText(url).then(
      function () {
        setTopMessageState({ type: 'copied', message: t('top.Copied Successfully') });
      },
      function (err) {},
    );
  };

  const tapChange = async (e) => {
    setIsLoadedState(true);

    let result = await DataModel.editMeeting(meetingIDState, 'changeURL');
    if (result != null) {
      if (result.meetingID != null) {
        //ローカルストレージに保存
        localStorage.setItem('meetingID', result.meetingID);

        //ミーティングIDを設定
        setMeetingIDState(result.meetingID);

        //メッセージ
        setTopMessageState({ type: 'copied', message: t('mypage.Saved!') });

        closeWindow();
      }
    } else {
      setTopMessageState({ type: 'copied', message: t('mypage.Error something wrong') });
    }
    setIsLoadedState(false);
  };

  return (
    <>
      <div className="isElectron">
        <Loading loadingState={isLoadedState} />
      </div>
      <div className="addAreaBack" onClick={closeWindow}></div>
      <div className="myroomWrap">
        <div className="myroomTitle">
          {t('setting.My meeting room')} <CloseSVG onClick={closeWindow} />
        </div>

        <div className="myroomURL">faceless.ooo/{meetingIDState}</div>

        <div className="myroomButtons">
          <div className="myroomButton copy" onClick={tapCopy}>
            {t('mypage.Copy URL')}
          </div>
          <div></div>
          <div className="myroomButton change" onClick={tapChange}>
            {t('mypage.Change URL')}
          </div>
        </div>
      </div>
    </>
  );
}
